<template>
    <v-container class="px-10">
        <div class="welcome-message mt-2 mb-3">
            Επιλογή χρωμάτων θέματος
        </div>
        <v-btn
            color="black"
            class="white--text my-4"
            @click="switchToDefault"
        >
            Default
        </v-btn>
        <div class="color-pickers">
            <div class="color-picker">
                <h4>Background</h4>
                <v-color-picker
                    class="ma-2"
                    dot-size="30"
                    light
                    elevation="3"
                    v-model="backgroundColor"
                ></v-color-picker>
            </div>
            <div class="color-picker">
                <h4>TopBar</h4>
                <v-color-picker
                    class="ma-2"
                    dot-size="30"
                    light
                    elevation="3"
                    v-model="topBarColor"
                ></v-color-picker>
            </div>
            <div class="color-picker">
                <h4>Sidebar</h4>
                <v-color-picker
                    class="ma-2"
                    dot-size="30"
                    light
                    elevation="3"
                    v-model="sideBarColor"
                ></v-color-picker>
            </div>
            <div class="color-picker">
                <h4>Sidebar Text</h4>
                <v-color-picker
                    class="ma-2"
                    dot-size="30"
                    light
                    elevation="3"
                    v-model="sideBarText"
                ></v-color-picker>
            </div>
            <div class="color-picker">
                <h4>Cards and Tables</h4>
                <v-color-picker
                    class="ma-2"
                    dot-size="30"
                    light
                    elevation="3"
                    v-model="cardsAndTablesColor"
                ></v-color-picker>
            </div>
            <div class="color-picker">
                <h4>Cards and Tables Text</h4>
                <v-color-picker
                    class="ma-2"
                    dot-size="30"
                    light
                    elevation="3"
                    v-model="cardsAndTablesText"
                ></v-color-picker>
            </div>
        </div>
        <div class="submit-button-wrapper">
            <v-btn
                color="black"
                class="white--text mx-2"
                @click="updateUserTheming"
            >
                ΥΠΟΒΟΛΗ
            </v-btn>
        </div>
    </v-container>
</template>
<script>
    import theming from '@/services/theming'
    export default {
        data() {
            return {
                defaultColor: '#ffffff',
                backgroundColor: '#ffffff',
                topBarColor: '#ffffff',
                cardsAndTablesColor: '#ffffff',
                sideBarColor: '#ffffff',
                cardsAndTablesText: '#000000',
                sideBarText: '#000000',
                currentUserTheming: null
            }
        },
        created() {
            this.getUserTheming()
        },
        methods: {
            getUserTheming() {
                theming.getTheming().then(resp => {
                    if (resp.data.config) {
                        this.backgroundColor = resp.data.config.backgroundColor || '#ffffff'
                        this.topBarColor = resp.data.config.topBarColor || '#ffffff'
                        this.sideBarColor = resp.data.config.sideBarColor || '#ffffff'
                        this.sideBarText = resp.data.config.sideBarText || '#000000'
                        this.cardsAndTablesColor = resp.data.config.cardsAndTablesColor || '#ffffff'
                        this.cardsAndTablesText = resp.data.config.cardsAndTablesText || '#000000'
                    }
                })
            },
            switchToDefault() {
                this.backgroundColor = '#ffffff'
                this.topBarColor = '#ffffff'
                this.sideBarColor = '#ffffff'
                this.sideBarText = '#000000'
                this.cardsAndTablesColor = '#ffffff'
                this.cardsAndTablesText = '#000000'
            },
            updateUserTheming() {
                const colors = {
                    config: {
                        backgroundColor: this.backgroundColor,
                        topBarColor: this.topBarColor,
                        sideBarColor: this.sideBarColor,
                        sideBarText: this.sideBarText,
                        cardsAndTablesColor: this.cardsAndTablesColor,
                        cardsAndTablesText: this.cardsAndTablesText
                    }
                }
                theming.updateTheming(colors).then(resp => {
                    location.reload()
                })
            }
        }
    }
</script>
<style scoped>
.container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.welcome-message {
    text-align: center;
    font-weight: bold;
    font-size: 1.5rem;
    color: var(--cards-and-tables-text-color) !important;
}

.color-pickers {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.color-picker {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: var(--cards-and-tables-text-color) !important;
}

</style>
